import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '../../material.module'
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { ShareMapComponent } from './share-map.component';
import { ShareMapDialogComponent } from './share-map-dialog/share-map-dialog.component';
import { QRCodeComponent } from 'angularx-qrcode';

@NgModule({
    declarations: [
        // ShareMapComponent
        // , ShareMapDialogComponent
    ],
    imports: [
        // CommonModule,
        // MaterialModule,
        // TranslateModule,
        // QRCodeComponent   
    ],
    bootstrap: [
        // ShareMapComponent, ShareMapDialogComponent
    ],
    providers: [
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } }
    ],
    exports: [
        // ShareMapComponent,
        // ShareMapDialogComponent
    ]
})
export class ShareMapModule { }
